import React from 'react';
import { useTranslation } from 'react-i18next';
import PeopleForm from './PeopleForm';

interface OnboardingProps {
  onClose: () => void;
}

const Onboarding: React.FC<OnboardingProps> = ({ onClose }) => {
  const { t } = useTranslation();

  const handleSuccess = () => {
    onClose();
  };

  return (
    <div className="h-screen">
      <PeopleForm
        onSuccess={handleSuccess}
        onCancel={onClose}
      />
    </div>
  );
};

export default Onboarding;
